import { createRouter, createWebHashHistory } from "vue-router";
import Layout from "@/layout/index.vue";
import { isRouteAllowedForAccount } from "@/utils/accountPermission";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "Home",
        component: () => import("@/views/home/index.vue"),
        meta: {
          title: "首页",
          icon: "House",
        },
      },
      {
        path: "projects",
        name: "Projects",
        component: () => import("@/views/projects/index.vue"),
        meta: {
          title: "我的项目",
          icon: "FolderOpened",
        },
      },
      {
        path: "detail/:id",
        name: "Detail",
        component: () => import("@/views/detail/index.vue"),
        meta: {
          title: "作品详情",
        },
      },
      {
        path: "editor/:id",
        name: "Editor",
        component: () => import("@/views/editor/index.vue"),
        meta: {
          title: "项目编辑",
        },
      },
      {
        path: "myAssets",
        name: "myAssets",
        component: () => import("@/views/myAssets/index.vue"),
        meta: {
          title: "我的资产",
          icon: "CreditCard",
        },
      },
      {
        path: "freeCreate",
        name: "FreeCreateList",
        component: () => import("@/views/freeCreate/list.vue"),
        meta: {
          title: "自由创作",
          icon: "EditPen",
        },
      },
      {
        path: "classicMode",
        name: "ClassicModeList",
        component: () => import("@/views/classicMode/list.vue"),
        meta: {
          title: "经典模式",
          icon: "Film",
        },
      },
      {
        path: "classicMode/:id",
        name: "ClassicModeDetail",
        component: () => import("@/views/classicMode/detail.vue"),
        meta: {
          title: "经典模式详情",
        },
      },
      {
        path: "orderSquare",
        name: "OrderSquare",
        component: () => import("@/views/orderSquare/index.vue"),
        meta: {
          title: "接单广场",
          icon: "Briefcase",
        },
      },
      {
        path: "community",
        name: "Community",
        component: () => import("@/views/community/index.vue"),
        meta: {
          title: "社区&活动",
          icon: "ChatLineRound",
          keepAlive: true,
        },
      },
      {
        path: "community/activities",
        name: "CommunityActivities",
        component: () => import("@/views/community/activities.vue"),
        meta: {
          title: "社区活动",
        },
      },
      {
        path: "community/hot",
        name: "CommunityHotCommunities",
        component: () => import("@/views/community/hotCommunities.vue"),
        meta: {
          title: "社区热门",
        },
      },
      {
        path: "community/activities/:activityId",
        name: "CommunityActivityDetail",
        component: () => import("@/views/community/activityDetail.vue"),
        meta: {
          title: "活动详情",
        },
      },
      {
        path: "community/:id",
        name: "CommunityDetail",
        component: () => import("@/views/community/detail.vue"),
        meta: {
          title: "帖子详情",
        },
      },
      {
        path: "orderSquare/my",
        name: "OrderSquareMyOrders",
        component: () => import("@/views/orderSquare/myOrders.vue"),
        meta: {
          title: "我的商单",
        },
      },
      {
        path: "orderSquare/:id",
        name: "OrderSquareDetail",
        component: () => import("@/views/orderSquare/detail.vue"),
        meta: {
          title: "商单详情",
        },
      },
      {
        path: "freeCreate/:id",
        name: "FreeCreateCanvas",
        component: () => import("@/views/freeCreate/canvas.vue"),
        meta: {
          title: "无限画布",
        },
      },
      {
        path: "test3d",
        name: "Test3d",
        component: () => import("@/views/test3d/index.vue"),
        meta: {
          title: "3D测试",
          icon: "Monitor",
        },
      },
      {
        path: "myAssets/:id",
        name: "MyAssetDetail",
        component: () => import("@/views/myAssets/detail.vue"),
        meta: {
          title: "资产详情",
        },
      },
      {
        path: "invitation",
        name: "invitation",
        component: () => import("@/views/invitation/index.vue"),
        meta: {
          title: "邀请有礼",
          icon: "Present",
        },
      },
      {
        path: "credits",
        name: "Credits",
        component: () => import("@/views/credits/index.vue"),
        meta: {
          title: "算力",
          icon: "Lightning",
        },
      },
      {
        path: "profile",
        name: "Profile",
        component: () => import("@/views/profile/index.vue"),
        meta: {
          title: "个人信息",
          icon: "UserFilled",
        },
      },
      {
        path: "team",
        name: "team",
        component: () => import("@/views/team/index.vue"),
        meta: {
          title: "我的团队",
          icon: "Connection",
        },
      },
      {
        path: "revenue",
        name: "revenue",
        component: () => import("@/views/revenue/index.vue"),
        meta: {
          title: "我的收益",
          icon: "Money",
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

const whiteList = ["/login", "/", "/home"];

router.beforeEach((to, _, next) => {
  if (whiteList.includes(to.path)) {
    next();
  } else if (!localStorage.getItem("userId")) {
    next({
      path: "/login",
      replace: true,
    });
  } else if (!isRouteAllowedForAccount(to.path)) {
    next({
      path: "/home",
      replace: true,
    });
  } else {
    next();
  }
});

export default router;
